import { render } from "./Item8.vue?vue&type=template&id=57d3b1e6&ts=true"
import script from "./Item8.vue?vue&type=script&lang=ts"
export * from "./Item8.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__